// -----------------------------------------------------------------------------
// LicencePage — Gestion de l'abonnement StockPro
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../../i18n/translations";
import { getColors } from "../../styles/theme";
import { Ic, ICONS } from "../Icons";

export default function LicencePage({
  lang,
  dark,
  accent,
  authUser,
  userProfile,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary, borderColor } = getColors(dark);

  return (
    <div className="slide-in">
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:22, fontWeight:800, color:textPrimary }}>{t.licenceTitle}</h1>
        <p style={{ color:textSecondary, fontSize:12, marginTop:3 }}>Gérez votre abonnement StockPro</p>
      </div>

      {/* Statut licence */}
      <div className="card" style={{ padding:"22px", marginBottom:16, background:`linear-gradient(135deg,${accent}10,rgba(247,147,30,.08))`, borderColor:`${accent}30` }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
          <div>
            <div style={{ fontWeight:800, color:textPrimary, fontSize:16 }}>
              {userProfile?.licenceType==="trial" ? "Essai gratuit 14j" : userProfile?.licenceType==="monthly" ? "Mensuelle" : "Contrat annuel"}
            </div>
            <div style={{ fontSize:12, color:textSecondary, marginTop:3 }}>
              Expire le : <strong style={{ color:accent }}>{userProfile?.licenceEnd || "—"}</strong>
            </div>
          </div>
          <div style={{ padding:"6px 14px", borderRadius:20, background:userProfile?.licenceActive?"rgba(16,185,129,.15)":"rgba(239,68,68,.15)", border:`1px solid ${userProfile?.licenceActive?"rgba(16,185,129,.3)":"rgba(239,68,68,.3)"}` }}>
            <span style={{ fontSize:12, fontWeight:700, color:userProfile?.licenceActive?"#10b981":"#f87171" }}>
              {userProfile?.licenceActive ? "✓ Active" : "✗ Expirée"}
            </span>
          </div>
        </div>

        {/* Barre de progression */}
        {userProfile?.licenceEnd && (() => {
          // Calcul dynamique de la durée totale de la licence
          // Priorité 1 : licenceStart présent → durée réelle (end - start)
          // Priorité 2 : fallback selon le type de licence
          let total;
          if (userProfile.licenceStart) {
            total = Math.max(1, Math.ceil(
              (new Date(userProfile.licenceEnd) - new Date(userProfile.licenceStart)) / 86400000
            ));
          } else if (userProfile.licenceType === "trial") {
            total = 14;
          } else if (userProfile.licenceType === "monthly") {
            total = 30;
          } else {
            total = 365; // contrat annuel par défaut
          }
          const remaining = Math.max(0, Math.ceil((new Date(userProfile.licenceEnd) - new Date()) / 86400000));
          const pct = Math.min(100, (remaining/total)*100);
          return (
            <div>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
                <span style={{ fontSize:11, color:textSecondary }}>{remaining} jours restants</span>
                <span style={{ fontSize:11, color:textSecondary }}>{total} jours au total</span>
              </div>
              <div style={{ height:6, background:dark?"rgba(255,255,255,.05)":"rgba(0,0,0,.06)", borderRadius:3 }}>
                <div style={{ height:"100%", width:`${pct}%`, background:pct>50?"#10b981":pct>20?"#f59e0b":"#ef4444", borderRadius:3, transition:".4s" }} />
              </div>
            </div>
          );
        })()}
      </div>

      {/* Renouveler */}
      <div className="card" style={{ padding:"22px", marginBottom:16 }}>
        <div style={{ fontWeight:700, color:textPrimary, fontSize:15, marginBottom:8 }}>{t.licenceRenew}</div>
        <p style={{ fontSize:13, color:textSecondary, marginBottom:16 }}>Contactez VisualisPro pour renouveler ou mettre à niveau votre licence.</p>
        <div style={{ display:"flex", gap:10 }}>
          <a
            href="https://wa.me/32465952862?text=Bonjour+VisualisPro,+je+voudrais+renouveler+ma+licence+StockPro."
            target="_blank"
            rel="noreferrer"
            style={{ flex:1, padding:"11px", borderRadius:10, background:"#25D366", color:"#fff", fontWeight:700, fontSize:14, textDecoration:"none", textAlign:"center", display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}
          >
            <Ic d={ICONS.phone} size={16} color="#fff" /> WhatsApp
          </a>
          <a
            href="mailto:contact@visualispro.be?subject=Renouvellement licence StockPro"
            style={{ flex:1, padding:"11px", borderRadius:10, background:dark?"rgba(255,255,255,.08)":"rgba(0,0,0,.06)", color:textPrimary, fontWeight:700, fontSize:14, textDecoration:"none", textAlign:"center", display:"flex", alignItems:"center", justifyContent:"center", gap:8, border:`1px solid ${borderColor}` }}
          >
            <Ic d={ICONS.mail} size={16} /> Email
          </a>
        </div>
      </div>

      {/* Compte */}
      <div className="card" style={{ padding:"18px 20px" }}>
        <div style={{ fontWeight:700, color:textPrimary, marginBottom:8, fontSize:14 }}>Compte connecté</div>
        <div style={{ color:textSecondary, fontSize:13 }}>{authUser.email}</div>
        <div style={{ color:textSecondary, fontSize:12, marginTop:4 }}>
          UID : <span style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11 }}>{authUser.uid}</span>
        </div>
      </div>
    </div>
  );
}
